export default __webpack_public_path__ + "static/media/lifetap.70a05f9b.png";